export default __webpack_public_path__ + "static/media/Ivy-county-brochure.428361c5.pdf";